export default {
  title: 'Company Overview',
  description: "Welcome back, {{name}}! Here's what's happening with your marketing.",
};
